import type {
  OAuth2Config,
  OAuth2RefreshResponse,
  OAuth2ResetResponse,
  OAuth2Status,
  OAuth2TestResponse,
} from '../types/oauth2Dashboard'
import api from '@/integrations/axios/axios-instance'

const OAUTH2_BASE_URL = '/oauth2'

export const oauth2DashboardApi = {
  async getStatus(): Promise<OAuth2Status> {
    const response = await api.get(`${OAUTH2_BASE_URL}/status`)
    return response.data
  },

  async getConfig(): Promise<OAuth2Config> {
    const response = await api.get(`${OAUTH2_BASE_URL}/config`)
    return response.data
  },

  async testConnection(): Promise<OAuth2TestResponse> {
    const response = await api.post(`${OAUTH2_BASE_URL}/test-connection`)
    return response.data
  },

  async reset(): Promise<OAuth2ResetResponse> {
    const response = await api.post(`${OAUTH2_BASE_URL}/reset`)
    return response.data
  },

  async refreshToken(): Promise<OAuth2RefreshResponse> {
    const response = await api.post(`${OAUTH2_BASE_URL}/refresh-token`)
    return response.data
  },
}
